import { useRef, useState } from "react";

export function DropZone({ onFiles, disabled }) {
  const [over, setOver] = useState(false);
  const input = useRef(null);
  const take = (list) => { if (!disabled && list?.length) onFiles(Array.from(list)); };
  return (
    <div
      data-testid="undertake-dropzone"
      onClick={() => !disabled && input.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); take(e.dataTransfer.files); }}
      className="w-full h-56 flex items-center justify-center cursor-pointer transition-colors duration-200"
      style={{ border: `1px dashed ${over ? "var(--accent)" : "var(--border)"}`, color: over ? "var(--accent)" : "var(--text-muted)", background: over ? "var(--bg-secondary)" : "transparent", opacity: disabled ? 0.4 : 1 }}
    >
      <span className="font-head text-2xl tracking-widest">drag + drop</span>
      <input ref={input} type="file" multiple hidden data-testid="undertake-file-input" onChange={(e) => { take(e.target.files); e.target.value = ""; }} />
    </div>
  );
}
